import { useStorage } from "core";
import React from "react";
import { useTranslation } from "react-i18next";

export const useTrans = (namespace = "translation") => {
	const { setItem, getItem } = useStorage();
	const { t, i18n } = useTranslation(namespace);
	React.useEffect(() => {
		const lang = getItem("language") || "en";
		i18n.changeLanguage(lang);
		document.documentElement.setAttribute("lang", lang);
	}, [getItem, i18n]);

	React.useEffect(() => {
		document.documentElement.dir = i18n.dir();
	}, [i18n]);

	const handleChangeLanguage = (lang) => {
		document.documentElement.setAttribute("lang", lang);
		i18n.changeLanguage(lang);
		setItem("language", lang);
	};

	return {
		t,
		i18n,
		changeLanguage: handleChangeLanguage,
		addResourceBundle: i18n.addResourceBundle.bind(i18n),
	};
};

export default useTrans;
